import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ClientContext = createContext(null);
const STORAGE_KEY = "itassess_active_client";

export function ClientProvider({ children }) {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [activeClientId, setActiveClientIdState] = useState(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    return v && v !== "null" ? v : null;
  });

  const setActiveClient = useCallback((id) => {
    setActiveClientIdState(id);
    localStorage.setItem(STORAGE_KEY, id || "null");
  }, []);

  const loadClients = useCallback(async () => {
    try {
      const { data } = await api.get("/clients");
      setClients(data);
      // if stored active client no longer exists, reset to portfolio
      setActiveClientIdState((cur) => (cur && !data.some((c) => c.id === cur) ? null : cur));
    } catch {
      setClients([]);
    }
  }, []);

  useEffect(() => { if (user && !user.is_platform_admin) loadClients(); }, [user, loadClients]);

  const activeClient = clients.find((c) => c.id === activeClientId) || null;

  return (
    <ClientContext.Provider value={{ clients, activeClientId, activeClient, setActiveClient, loadClients }}>
      {children}
    </ClientContext.Provider>
  );
}

export const useClient = () => useContext(ClientContext);
